// extracted by mini-css-extract-plugin
module.exports = {"header":"PdpRespSeoLinks__header__a08a9b32","links":"PdpRespSeoLinks__links__a08a9b32","link":"PdpRespSeoLinks__link__a08a9b32"};